import request from '../../../shared/request'

export function getLeadAttachments(lead_id) {
  return request(`/lead/attachments/${lead_id}/`)
}

export function createLeadAttachment(payload) {
  return request(`/lead/attachments/${payload.lead_id}/`, {
    method: 'POST',
    body: payload.file,
    headers: {
      Accept: 'application/json'
    }
  })
}

export function updateLeadAttachment(payload) {
  return request(`/lead/attachments/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteLeadAttachment(payload) {
  return request(`/lead/attachments/${payload.attachment_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/lead/attachments.js